import { render, staticRenderFns } from "./ParcelsSettings.vue?vue&type=template&id=7f1881d6&"
import script from "./ParcelsSettings.vue?vue&type=script&lang=js&"
export * from "./ParcelsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports